import type { AppValidationVote } from '@api';

import { getProcessEnvGlobalConfig } from '@shared/config/global';
import formatUsername from '@shared/helpers/formatUsername';

import type { ApplicationTableData } from '@ui/uikit/components/applications/common/ApplicationValidationSummary';

export const mapVote = (vote: AppValidationVote): ApplicationTableData => {
  const { icon, karma, magicId, choice, votingPower, wallet, membership } = vote;

  return {
    id: magicId,
    icon,
    karma,
    name: formatUsername(vote, wallet),
    choice,
    votingPower,
    profileUrl: `${getProcessEnvGlobalConfig('host')}${getProcessEnvGlobalConfig(
      'basePath',
    )}/user/${magicId}`,
    membership: membership?.tier,
  };
};
